// Converts url hash params:
//   "#foo=foo%20foo&bar=bar%20bar"
// into a js object:
//   { foo: "foo foo", bar: "bar bar" }

export const getDecodedQueryParamsFromUri = (uri) => {
    const parts = uri.split("?");
    const hasQuery = parts.length > 1;
    if (!hasQuery) {
        return {};
    }
    const queryString = parts.pop();
    const queryStringParts = queryString.split("&");
    return queryStringParts
        .map((part) => {
            const tmp = {};
            const [key, value] = part.split("=");
            tmp[decodeURIComponent(key)] = decodeURIComponent(value);
            return tmp;
        })
        .reduce((acc, curr) => Object.assign(acc, curr), {});
};

export const getDecodedQueryParamsFromWindow = () => {
    return getDecodedQueryParamsFromUri(window.location.hash);
};
